import { render, staticRenderFns } from "./TotalName.vue?vue&type=template&id=197d7688&scoped=true&"
import script from "./TotalName.vue?vue&type=script&lang=js&"
export * from "./TotalName.vue?vue&type=script&lang=js&"
import style0 from "./TotalName.vue?vue&type=style&index=0&id=197d7688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197d7688",
  null
  
)

export default component.exports